import client from './client';

// 버튼별 권한 코드(ActionPermissionService). bito 4단계(2026-10-20).
// 메뉴 접근 권한(SYS_MENU_AUTH)과는 별개로, 화면 안의 특정 버튼/동작(기회 복사/기회 실패/
// 매입단가 0원 입력 등) 단위 권한이다.
const BASE_URL = '/api/v1/auth/actions';

/** 로그인 사용자 본인의 권한 코드. { isAdmin, codes: [...] } */
export const getMyActions = () => client.get(BASE_URL);

/** 관리자용 — 특정 대상(사용자/부서)에 지금 부여된 코드. targetType: 'USER' | 'DEPT' */
export const getTargetActions = (targetType, targetId) =>
  client.get(`${BASE_URL}/${targetType}/${targetId}`);

/** 관리자용 — 특정 대상의 권한 코드를 교체(이 기능이 아는 코드만 바뀐다). */
export const setTargetActions = (targetType, targetId, codes) =>
  client.put(`${BASE_URL}/${targetType}/${targetId}`, { codes });
